import React, { useState, useEffect } from 'react';
import { useRemoveItemFromCart, useUpdateItemQuantity } from '../../context/storeContext';

import iconTrash from '../../images/icon-trash-alt.svg';
import CurrencySwitcher from '../Header/currencyswitcher/CurrencySwitcher';
import {
  formatCartPackageDisplay,
  getTierPrice,
  qualifiesForBulkDiscount,
} from '../../utils/discounts';

export default ({ item: cart }) => {
  const removeItemFromCartById = useRemoveItemFromCart();
  const updateItemQuantityById = useUpdateItemQuantity();

  const [quantity, setQuantity] = useState(cart?.quantity);

  useEffect(() => {
    setQuantity(cart?.quantity);
  }, [cart?.quantity]);

  const commitQuantity = (nextQuantity) => {
    const updatedQuantity = parseInt(nextQuantity, 10);
    if (isNaN(updatedQuantity) || updatedQuantity < 1) {
      setQuantity(cart?.quantity || 1);
      return;
    }

    setQuantity(updatedQuantity);
    if (updatedQuantity !== cart?.quantity) {
      updateItemQuantityById(cart?.id, updatedQuantity);
    }
  };

  const handleQuantityChanged = (lineItemId, changeAmount) => {
    const currentQuantity = parseInt(quantity, 10) || cart?.quantity || 1;
    const updatedQuantity = currentQuantity + changeAmount;
    if (updatedQuantity > 0) {
      updateItemQuantityById(lineItemId, updatedQuantity);
      setQuantity(updatedQuantity);
    }
  };

  const image_source = cart.image;
  const isColouringBook = cart.tierScheme === 'colouring';
  const listPrice = Number(cart.originalPrice) || Number(cart.price) || 0;
  const parsedQuantity = parseInt(quantity, 10);
  const orderAmount =
    !Number.isNaN(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : cart?.quantity || 1;

  const unitPrice = isColouringBook
    ? qualifiesForBulkDiscount('colouring', orderAmount)
      ? parseFloat(getTierPrice('colouring', listPrice, orderAmount))
      : listPrice
    : Number(cart.price) || 0;

  const discountedSubtotal = unitPrice * orderAmount;
  const pricePerBookFromSubtotal =
    orderAmount > 0 ? discountedSubtotal / orderAmount : unitPrice;
  const showRetailSubtotal = isColouringBook
    ? unitPrice < listPrice
    : cart.hasDiscount && listPrice > unitPrice;

  const renderAttributeValue = (key, value) => {
    if (key !== 'package') {
      return value;
    }

    const displayValue = formatCartPackageDisplay(value);
    const match = displayValue.match(/^(.+?)\s*(\(.+\))$/i);
    if (!match) {
      return displayValue;
    }

    return (
      <>
        {match[1]}{' '}
        <span className="cart-product-package-numbers" title={match[2]}>
          {match[2]}
        </span>
      </>
    );
  };

  return (
    <div className="cart-product">
      <div className="cart-product-image">
        <img src={image_source} alt="Product Image" />
      </div>
      <div className="cart-product-contents">
        <div className="cart-content-top">
          <div className="cart-product-name">{cart?.title || 'N/A'}</div>
          <div className="cart-product-clear">
            <a href="#" onClick={() => removeItemFromCartById(cart.id)}>
              <img src={iconTrash} alt="Trash Icon" /> Remove
            </a>
          </div>
        </div>
        <div className="cart-content-bottom">
          <div className="cart-content-package-row">
            {!!cart?.customAttr
              ? Object.entries(cart.customAttr).map(([key, value]) => (
                <span key={key} className="cart-product-color">
                  {key}:{' '}
                  <span
                    className="cart-product-attribute"
                    title={key === 'package' ? formatCartPackageDisplay(value) : undefined}
                  >
                    {renderAttributeValue(key, value)}
                  </span>
                </span>
              ))
              : null}
            <span className="cart-product-amount">
              Amount
              <span className="cart-number">
                <span className="cart-minus" onClick={() => handleQuantityChanged(cart?.id, -1)} tabIndex={-1}>
                  -
                </span>
                <input
                  type="text"
                  inputMode="numeric"
                  value={quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '') {
                      setQuantity('');
                      return;
                    }
                    if (!/^\d+$/.test(value)) return;
                    setQuantity(parseInt(value, 10));
                  }}
                  onBlur={(e) => commitQuantity(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.target.blur();
                    }
                  }}
                />
                <span className="cart-plus" onClick={() => handleQuantityChanged(cart?.id, 1)} tabIndex={-1}>
                  +
                </span>
              </span>
            </span>
          </div>
          {isColouringBook && (
            <div className="cart-content-price-row">
              <span className="cart-product-unit-price">
                <span>Price</span>
                <span className="cart-unit-price-amount">
                  <CurrencySwitcher price={pricePerBookFromSubtotal} caller="cart item unit" />
                </span>
              </span>
            </div>
          )}
          <div className="cart-content-subtotal-row">
            <span className="cart-product-subtotal">
              <span>Subtotal</span>
              <span className="cart-subtotal-amount">
                {showRetailSubtotal && (
                  <s className="cart-subtotal-original">
                    <CurrencySwitcher price={listPrice * orderAmount} caller="cart item original" />
                  </s>
                )}
                <CurrencySwitcher price={discountedSubtotal} caller="cart item" />
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

